// extracted by mini-css-extract-plugin
export var bubble = "_3h-0";
export var container = "_3h-f";
export var contrastBorder = "_3h-g";
export var greyOut = "_3h-2";
export var initialsColor0 = "_3h-3";
export var initialsColor1 = "_3h-4";
export var initialsColor10 = "_3h-d";
export var initialsColor11 = "_3h-e";
export var initialsColor2 = "_3h-5";
export var initialsColor3 = "_3h-6";
export var initialsColor4 = "_3h-7";
export var initialsColor5 = "_3h-8";
export var initialsColor6 = "_3h-9";
export var initialsColor7 = "_3h-a";
export var initialsColor8 = "_3h-b";
export var initialsColor9 = "_3h-c";
export var initialsWrapper = "_3h-1";
export var large = "_3h-l";
export var medium = "_3h-k";
export var mediumSmall = "_3h-j";
export var mediumSmallMedium = "_3h-o";
export var micro = "_3h-h";
export var small = "_3h-i";
export var tiny = "_3h-n";
export var xTiny = "_3h-m";